const embedCodeFor = (alias) => {
    return `<a href="${process.env.REACT_APP_WITHFRIENDS_HOST}/${alias}/join?utm_campaign=wf-websitelink">
    <img src="${process.env.REACT_APP_ASSET_HOST}/api/embed-btn.svg" width="225"/>
</a>
<script type="text/javascript" src="${process.env.REACT_APP_ASSET_HOST}/api/wf-embed-btn.js?b=${alias}"></script>`;
};
export { embedCodeFor };
